/**
 * Created by juraj.homola on 1. 3. 2017.
 */

import i18n from '@i18n';
import { isSimilar } from 'nike-ui/src/components/registration/util/password-validator';

export function empty(emptyErrorKey) {
    return value => {
        if (!value) {
            return i18n(emptyErrorKey);
        }
        return null;
    };
}

export function loginPasswordSubCheck(password, username) {
    if (!PASSWORD_REGEX.test(password)) {
        return i18n('error.validacia.formular.registracia.heslo');
    }
    if (!/^\S/.test(password)) {
        return i18n('error.validacia.formular.registracia.hesloSpace');
    }
    if (!/\S$/.test(password)) {
        return i18n('error.validacia.formular.registracia.hesloSpace');
    }
    if (password && username && username.length > 3 && isSimilar(username, password)) {
        return i18n('error.validacia.formular.registracia.hesloSimilarity');
    }
    if (password?.length > 64) {
        return i18n('validation.password.invalid.maxchars');
    }
    return null;
}

export const PATTERN_MESTO = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ\w\s\-,./]{0,20}$/;
export const PATTERN_ULICA_A_CISLO = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ\w\s\-,./]{0,28}$/;
export const PATTERN_ULICA_A_CISLO_30 = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ\w\s\-,./]{0,30}$/;

export const PATTERN_DIACRITIC_NONUMBERS_20 = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţa-zA-Z_\s\-,./]{0,20}$/;

export const PATTERN_TITLE = /^[\w\s\-,./]{0,10}$/;
export const PATTERN_EMAIL = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/i;

/*
    Aspon jedno cislo, aspon jedno male pismeno, aspon jedno velke pismeno, minimalne 8 znakov,
    povolene su len ascii znaky lebo telesoap pri registracii vyrobi z utf znakov iny hash ako my pri logine
 */
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\x20-\x7E]{8,}$/;

const PATTERN_PHONES = new RegExp(
    '^(' +
        [
            '(?:\\+4219\\d{8})',
            '(?:\\+36(?:20|30|31|62|70)\\d{7})',
            '(?:\\+48(?:50|51|53|57|60|66|69|72|73|78|79|88)\\d{7})',
            '(?:\\+380\\d{9})'
        ].join('|') +
        ')$'
);

export const patterns = {
    MESTO: PATTERN_MESTO,
    ULICA_A_CISLO: PATTERN_ULICA_A_CISLO,
    ULICA_A_CISLO_30: PATTERN_ULICA_A_CISLO_30,
    MENO: PATTERN_DIACRITIC_NONUMBERS_20,
    TITLE: PATTERN_TITLE,
    PHONE: PATTERN_PHONES,
    PSC: /^\d{5}$/,
    EMAIL: PATTERN_EMAIL
};
